{
  "version": 1,
  "asset_id": "65c2e00c-7488-4115-ac10-44f6e1f21623",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/65c2e00c-7488-4115-ac10-44f6e1f21623/gastric-bypass-v2-1200.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/65c2e00c-7488-4115-ac10-44f6e1f21623/gastric-bypass-v2-1200.webp",
  "original_filename": "gastric-bypass-v2-1200.webp",
  "size": 73918,
  "content_type": "image/webp",
  "created_at": "2026-09-25T13:00:54Z"
}
